
import Loader from "@/components/Loader.vue";
import { formatDate } from "@/helpers/formatters";
import { Vue, Component, Prop } from "vue-property-decorator";
import "@/helpers/filters";

@Component({ components: { Loader } })
export default class Analysen extends Vue {
  @Prop({ required: true })
  id!: string;

  paramId = "";
  probeartId = -1;
  datum = "";

  formatDate(date: string) {
    return formatDate(date);
  }

  get isValid() {
    return this.id && this.paramId && this.probeartId && this.datum;
  }

  get where() {
    return [
      "messst_nr=" + this.id,
      "param_gruppe_id=" + this.paramId,
      ...(this.probeartId == -1 ? [] : ["probeart_nr=" + this.probeartId]),
      "ana_datum=isodate:" + this.datum
    ];
  }

  onParameterLoaded(params: any[]) {
    if (!this.paramId && params.length) {
      this.paramId = params[0].param_id;
    }
  }

  onDatumLoaded(results: any[]) {
    if (!this.datum && results.length) {
      this.datum = results[0].ana_datum;
    }
  }

  onClickBezeichnung(stoff_nr: any) {
    console.log("Click on " + stoff_nr);
    this.$router.push({
      path: "/" + this.id + "/zeitreihen",
      query: { param: String(stoff_nr) }
    });
  }
}
